<template>
  <v-layout justify-center wrap>
    <v-flex shrink>
      <!-- Add new attribute -->
      <v-dialog v-model="show" lazy width="500">
        <!-- Activator button -->
        <template #activator="{ on }">
          <v-btn v-on="on" color="light-green" dark :loading="loading" round small>
            <v-icon>add_circle</v-icon>
          </v-btn>
        </template>
        <!-- Input to set a name -->
        <v-text-field
          v-model="name"
          append-icon="send"
          autofocus
          @click:append="createFeature"
          :error="error"
          hide-details
          @keyup.enter="createFeature"
          label="Nombre"
          prepend-inner-icon="edit"
          solo
        />
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from "vuex";

export default {
  data: () => ({
    error: false,
    name: null,
    show: false
  }),
  computed: {
    ...mapState("ner", {
      loading: state => state.loadingCreateFeature
    })
  },
  methods: {
    /**
     * Create a new feature for the current active classification.
     */
    createFeature() {
      if (!this.name) {
        this.error = true;
        return this.$notify.error("Por favor ingresa un nombre al atributo.");
      }

      this.error = false;
      this.$store
        .dispatch("ner/createFeature", this.name)
        .catch(() => {
          this.$notify.error(
            "Lo siento, tuvimos un problema. Por favor vuelve a intentar en unos segundos."
          );
        })
        .then(() => {
          this.show = false;
          this.name = null;
        });
    }
  }
};
</script>